import axios from 'axios'

function getCookie(name: string) {
  const cookies = document.cookie.split(';') // Split the string into individual cookies
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim() // Remove leading/trailing whitespace
    // Does this cookie string begin with the name we want?
    if (cookie.startsWith(`${name}=`)) {
      return cookie.substring(name.length + 1) // Return the cookie value
    }
  }
  return '' // Return empty string if cookie not found
}

const instance = axios.create({
  baseURL: import.meta.env.VITE_PD_AUTH_DOMAIN,
})

// This sets up axios to always get the user's access token prior to a request and attach it to the request Authorization header
instance.interceptors.request.use(async function (config) {
  const stytch_session_jwt = getCookie('stytch_session_jwt')
  const authorization = `Bearer ${stytch_session_jwt}`

  if (config.headers) {
    config.headers.Authorization = authorization
  } else {
    config.headers = {
      Authorization: authorization,
    }
  }
  // Comment out if we want to test against local pd-auth-api
  // if (config.url && import.meta.env.VITE_ENVIRONMENT === 'local') {
  //   // Dynamically set baseURL based on the URL of the API call
  //   config.baseURL = 'http://localhost:8018' // pd-auth-api
  // }

  return config
})

// Add response interceptor for global error logging
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Import enrichScopeForHttpError dynamically to avoid circular dependency
    const { enrichScopeForHttpError } = await import('../sentry')
    enrichScopeForHttpError(error)
    return Promise.reject(error)
  },
)

export default instance
